var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStarFigmaIcon = function SvgStarFigmaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.768.772 8.85 2.9l2.428.343c1.138.16 1.658 1.565.781 2.394l-1.744 1.65.41 2.323c.21 1.19-1.053 1.99-2.048 1.482L6.5 9.982l-2.177 1.11c-.996.508-2.258-.294-2.048-1.482l.41-2.324L.941 5.638c-.878-.83-.356-2.234.78-2.395l2.43-.343L5.232.772c.522-1.03 2.012-1.03 2.535 0Z",
    fill: "#FFC061"
  })));
};
export default SvgStarFigmaIcon;